import { render, staticRenderFns } from "./RedirectExternal.vue?vue&type=template&id=6e28cc8c&scoped=true&"
import script from "./RedirectExternal.vue?vue&type=script&lang=js&"
export * from "./RedirectExternal.vue?vue&type=script&lang=js&"
import style0 from "./RedirectExternal.vue?vue&type=style&index=0&id=6e28cc8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e28cc8c",
  null
  
)

component.options.__file = "RedirectExternal.vue"
export default component.exports